import { render, staticRenderFns } from "./ReportAssessment.vue?vue&type=template&id=208cdf49&scoped=true"
import script from "./ReportAssessment.vue?vue&type=script&lang=js"
export * from "./ReportAssessment.vue?vue&type=script&lang=js"
import style0 from "./ReportAssessment.vue?vue&type=style&index=0&id=208cdf49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208cdf49",
  null
  
)

export default component.exports